const $ = require('jquery');
window.$ = $;
// require('bootstrap');
require('slick-slider');
window.Readmore = require('readmore-js');

const Core = require("./core").default;
window.Core = Core;

const Dakkapel = require('./dakkapel').default;
window.Dakkapel = Dakkapel;

const GoogleMap = require("./map").default;
window.GoogleMap = GoogleMap;

